import { JobNotifications } from '../models/JobNotifications';
import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

interface JobNotificationsState extends ApiState {
  jobNotifications?: JobNotifications
}

export default requestReducer<JobNotificationsState>('UPDATE_JOB_NOTIFICATIONS')